const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * ATC EVENTS                                                                 *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.atcPhoneClicked, (location) => {
    pushEvent(
      createCustomEventGA4('contact', [
        ['type', 'telephone'],
        ['location', location],
      ])
    );
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
